import React from 'react';

import Checkbox from '@/src/components/common/Checkbox/Checkbox';
import {
  CheckboxFilterOption,
  FilterBoxTypes,
} from '@/src/components/common/FilterBox/V2/FilterBox';
import FilterCount from '@/src/components/myTasks/MyPortfolio/Elements/FilterCount/FilterCount';
import { TaskStatusEnum } from '@/src/components/task/Config';

import { getFilterOption, useMyPortfolio } from '../../../../../store/myPortfolio.store';
import CheckboxHeaderItem from '../../Header/HeaderItem/CheckboxHeaderItem';
import { ColumnOption } from '../Table';

const defaultCompletedStatusFilterOption = {
  id: TaskStatusEnum.Completed.toLowerCase().replace(/\s/g, '-'),
  label: TaskStatusEnum.Completed,
  key: TaskStatusEnum.Completed,
  value: TaskStatusEnum.Completed,
};

type StatusHeaderProps = {
  column: ColumnOption;
};

const StatusHeader = ({ column }: StatusHeaderProps) => {
  const { filterOptions, updateStatusFilterOption, completed } = useMyPortfolio();

  if (!filterOptions) {
    return <span>{column.title}</span>;
  }

  const filterOption = getFilterOption(filterOptions, column.column.name);

  if (filterOption.type !== FilterBoxTypes.Checkbox) {
    return <span>{column.title}</span>;
  }

  const isFilterCompleted = completed;

  // Manual completed handler
  const handleToggleCompleted = () => {
    updateStatusFilterOption({
      columnKey: column.column.name,
      filterOption: {
        ...filterOption,
        value: [
          ...filterOption.value
            .filter((f) => f.label !== TaskStatusEnum.Completed)
            .map((f) => {
              return {
                ...f,
                isActive: isFilterCompleted,
              };
            }),
          {
            ...defaultCompletedStatusFilterOption,
            isActive: !isFilterCompleted,
          },
        ],
      },
      completed: !isFilterCompleted,
    });
  };
  const handleUpdateFilters = (value: CheckboxFilterOption['value']) => {
    updateStatusFilterOption({
      columnKey: column.column.name,
      filterOption: {
        ...filterOption,
        value: [
          ...value,
          {
            ...defaultCompletedStatusFilterOption,
            isActive: false,
          },
        ],
      },
      completed: filterOption.value.find((f) => f.label === TaskStatusEnum.Completed).isActive,
    });
  };

  const handleReset = () => {
    updateStatusFilterOption({
      columnKey: column.column.name,
      filterOption: {
        ...filterOption,
        value: filterOption.value.map((f) => {
          if (f.label === TaskStatusEnum.Completed) {
            return { ...f, isActive: false };
          }
          return {
            ...f,
            isActive: true,
          };
        }),
      },
      completed: false,
    });
  };

  const mainFilterOption = {
    ...filterOption,
    value: filterOption.value.filter((f) => f.key !== TaskStatusEnum.Completed),
  };

  // Filter the options
  const bottomContent = (
    <div className="filterByContainer">
      <div className="filterItems">
        <div className="filterItem">
          <div className="filterCheckbox">
            <Checkbox
              value={isFilterCompleted}
              onChange={handleToggleCompleted}
              checked={isFilterCompleted}
            />
            <span style={{ width: 200 }}>Show Completed Tasks</span>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <div className="columnItemContainer tw-w-full">
        <CheckboxHeaderItem
          column={column}
          filterOption={mainFilterOption}
          bottomContent={bottomContent}
          disableFilters={isFilterCompleted}
          isForcedChecked={isFilterCompleted}
          onReset={handleReset}
          filterCountSlot={isFilterCompleted && <FilterCount onReset={handleReset} count={1} />}
          isForceFilterActive={isFilterCompleted}
          onUpdateFilters={handleUpdateFilters}
        />
      </div>
    </React.Fragment>
  );
};

export default StatusHeader;
